import Image from 'next/image';
import styled from 'styled-components';
export const CoverContainer = styled.div.withConfig({
  displayName: "Coverstyle__CoverContainer",
  componentId: "sc-1xf0tp2-0"
})(["", " .overlay-cover{", " background:#00000066;}"], {
  "position": "relative",
  "overflow": "hidden"
}, {
  "position": "absolute",
  "height": "100%",
  "width": "100%"
});
export const CoverBackground = styled.div.withConfig({
  displayName: "Coverstyle__CoverBackground",
  componentId: "sc-1xf0tp2-1"
})(["", " background-image:url(", ");"], {
  "position": "absolute",
  "inset": "0px",
  "backgroundSize": "cover",
  "backgroundPosition": "center",
  "backgroundRepeat": "no-repeat",
  "--tw-blur": "blur(24px)",
  "filter": "var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)"
}, ({
  $imageUrl
}) => `${$imageUrl}`);
export const CoverContent = styled.div.withConfig({
  displayName: "Coverstyle__CoverContent",
  componentId: "sc-1xf0tp2-2"
})(["", " max-width:", ";"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "flexDirection": "column"
}, ({
  theme
}) => `${theme.layout.width}`);
export const CoverImage = styled(Image).withConfig({
  displayName: "Coverstyle__CoverImage",
  componentId: "sc-1xf0tp2-3"
})(["", ""], {
  "position": "relative",
  "aspectRatio": "16 / 9",
  "objectFit": "cover"
});